
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Route, Routes } from "react-router-dom";
import {
  Table,
} from "reactstrap";
import { fetchAppointments } from "slices/appointmentSlice";

import Api from "services/api"
import AddAppointment from "components/appointment/AddAppointment";
import { removeAppointment } from "slices/appointmentSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { ListLayout } from "components/common/ListLayout";
import { SortButtons } from "components/common/SortButtons";
import { CustomSwitch } from "components/common/Switch";
import { changeStatus } from "slices/appointmentSlice";
import { removeMultipleAppointments } from "slices/appointmentSlice";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { convertTimeToUTC } from "helpers/convertTimeToUTC";
import { PAGELENGTH } from "components/common/ListLayout";
import { appointmentsSelector } from "slices/appointmentSlice";
import { setSuccessMessage } from "slices/appSlice";
import SuccessMessageModal from "components/SuccessMessageModal";
import { setAddAppointmentPopup } from "slices/appointmentSlice";
import AppointmentView from "./appointment/view";
import InviteInterpreter from "./appointment/view/InviteInterpreter";
import { usePermissions } from "layouts/Admin";
import { getBackgroundStyle, getConfirmationRowClass, getConfirmationBadge } from "components/common/TableColor";
import formatDateTimeByTimezone from 'hooks/formatDateTimeByTimezone';
import moment from "moment";
import JoinRoomCall from "./JoinRoomCall/JoinRoomCall";
const apiService = new Api();

const appointmentRoutes = [
  {
    path: "",
    component: <AppointmentList />,
  },
  {
    path: "view/:id",
    component: <AppointmentView />,
  },
    {
    path: "view/join-room-call/:id",
    component: <JoinRoomCall />,
  },
  {
    path: "invite-interpreter/:id",
    component: <InviteInterpreter />,
  },
]

export const AppointmentRoutes = () => {

  return (
    <Routes>
      {appointmentRoutes.map(({ path, component }) => (
        <Route key={path} path={path} element={component} />
      ))}
    </Routes>
  )

}

function AppointmentList() {
  const dispatch = useDispatch()
  const { checkPermission } = usePermissions()

  const { appointments, last_page: totalPages, loader, total, current_page, per_page: pageLength } = useSelector(appointmentsSelector);
  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {}

  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [selectedValue, setSelectedValue] = React.useState([10])
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: 'name',
    sortDirection: 'asc',
  });

  React.useEffect(() => {
    dispatch(fetchAppointments(1, {pageLength : 10}))
  }, [])

  const handleAddAppointmentPopUp = (item) => {
    dispatch(setAddAppointmentPopup({
      show: true,
      item,
    }))
  };

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      })
      setSelectedItems([]);
      setSelectAll(false)
      dispatch(fetchAppointments(1, {pageLength : 10}))
      hideConfirmDialog()
    }
    else {
      toast.error(message,
        {
          className: "errorToast",
        }
      );
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  }
  const handleRemoveItems = () => {
    dispatch(removeMultipleAppointments({ ids: selectedItems }, submitCallback))
  }
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value
    setSelectedItems(
      selectedItems.includes(id) ?
        selectedItems.filter((item) => item != id) :
        [...selectedItems, id]
    )
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([])
      setSelectAll(false)
      return
    }
    setSelectAll(true)
    setSelectedItems(appointments && appointments?.map((appointment) => appointment.id.toString()))


  }

  const handlePageChange = React.useCallback((page) => {
    setCurrentPage(page);
    dispatch(fetchAppointments(page));
  }, [])

  const handleClose = () => {
    // refAddutton.current.click(); 
    setAddForm({ show: false });

  };

  const handleSelect = (value) => {
    setSelectedValue(value)

  }


  //#region TABLE HEAD 

  const renderTableHeader = React.useCallback(() => {


    const callBack = (dir, sortBy) => {

      setSortConfig({ sortBy, sortDirection: dir })
      dispatch(fetchAppointments(currentPage, { sortBy: sortBy, sortDirection: dir, search: searchTerm }))
    }
    return (
      <tr>
        <th className="col-1">
          <div className="row_check">
            <span>#</span>
            {checkPermission('Delete Appointments') &&
              <label className="custom-checkbox checkbox"><input type="checkbox" name="select-all" checked={selectAll} onChange={handleToggleSelectAll} /><span className="checkmark"></span></label>
            }
          </div>
        </th>


        <th>

          <TableHeaderItem
            title="appid"
            sortBy="appid"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>




        <th className="col-2">
          <TableHeaderItem
            title="Service"
            sortBy="type"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Date"
            sortBy="date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        
        <th className="col-2">
          <TableHeaderItem
            title="Language"
            sortBy="language"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Interpreter"
            sortBy="interpreter"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th className="col-2">
          <TableHeaderItem
            title="Client"
            sortBy="client"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>


        <th className="col-2">
          <TableHeaderItem
            title="Creation Date"
            sortBy="created_at"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th className="col-1">
          <TableHeaderItem
            title="Status"
            sortBy="status"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        {checkPermission('Edit Appointments') &&
          <th className="col-1">Actions</th>
        }
      </tr>
    )
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems, appointments]);

  //#endregion


  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return (
      appointments && appointments?.map((appointment, index) => (
        <AppointmentItem appointment={appointment} index={index} selectedItems={selectedItems} handleChange={handleChange} handleAddPopUp={handleAddAppointmentPopUp} current_page={current_page} pageLength={pageLength} checkPermission={checkPermission} />
      ))
    )
  }, [appointments, selectedItems, current_page]);

  //#endregion

  return (
    <ListLayout
      heading="Appointments"
      time={true}
      title=""
      buttonTitle="Add Appointment"
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      addButtonDisabled={!checkPermission('Add Appointments')}
      totalPages={totalPages}
      fetchList={fetchAppointments}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      // renderAddForm={(callback) => <AddAppointment item={addForm.item} show={addForm.show} onClose={handleClose} callback={callback} />}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      handleAddPopUp={handleAddAppointmentPopUp}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      searchPlaceholder="Search Appointments ..."
      noOfItems={total}
      refAddPopUp="#addAppointmentPopUp"
      disableBootstrap={true}
    >
      <SuccessMessageModal />

      {deleteModal && <ConfirmationModal onClose={hideConfirmDialog} isOpen={deleteModal} onConfirm={handleRemoveItems} />}
    </ListLayout>
  )

}


const AppointmentItem = ({
  appointment, index, selectedItems, handleChange, handleAddPopUp, current_page, pageLength, checkPermission
}) => {
  const dispatch = useDispatch();
  const [status, setStatus] = React.useState(appointment?.status == "active" ? 1 : 0 || 0);

  const handleStatusChange = (id, s) => {
    setStatus(s ? 1 : 0)
    dispatch(changeStatus(id, { status: s ? 1 : 0 }));

  }
  useEffect(() => {
    setStatus(
      appointment?.status
    )

  }, [appointment]);

  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);


  const statuses = [
    {
      label: "Available",
      value: "available",
    },
    {
      label: "Assigned",
      value: "assigned",
    }, {
      label: "DNC",
      value: "dnc",
    },
    {
      label: "CNC",
      value: "cnc",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "Cancelled",
      value: "cancelled",
    }
  ]

  const ClientTimezone = appointment?.appointment_details?.timezone;
  const rawDatetime = appointment?.datetime;
  
  // ➤ Date only (no timezone conversion needed)
  const formattedDate = moment.utc(rawDatetime).format('MMM D, YYYY hh:mm A');

  
  // ➤ Time in UTC (default)
  const formattedDefaultTime = moment.utc(rawDatetime).format('hh:mm A');
  
  const formattedClientTime =  ClientTimezone ? formatDateTimeByTimezone(rawDatetime, ClientTimezone, 'time') : formattedDefaultTime;
  
  const rowClass = getConfirmationRowClass(appointment);
  const tdStyle = rowClass ? {} : getBackgroundStyle(appointment?.status);
  const confirmationBadge = getConfirmationBadge(appointment);
  
  return (
    <tr className={rowClass}>
      <td style={tdStyle}>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission('Delete Appointments') &&
            <label className="custom-checkbox checkbox">
              <input type="checkbox" name="select-all" data-value={appointment.id} checked={selectedItems.includes(appointment.id.toString())} onChange={handleChange} />
              <span className="checkmark"></span>
            </label>
          }
        </div>
      </td>
      <td style={tdStyle}>
        {checkPermission('Detail Appointments') ?
          <Link className='link_preview' to={`/appointments/view/${appointment?.id}`}>
            {appointment?.appid}
          </Link>
          :
          appointment?.appid
        }
      </td>
      <td style={tdStyle}>
        {appointment?.type || 'N/A'}
      </td>
      <td style={tdStyle}>
       
        { formattedDate  || 'N/A'}
      </td>
      <td style={tdStyle}>
        {appointment?.language?.name}
      </td>
      <td style={tdStyle}>
        {appointment?.interpreter?.first_name  ?  (appointment?.interpreter?.first_name + " " + appointment?.interpreter?.last_name) : "Not Assign"}
      </td>
      <td style={tdStyle}>
        {appointment?.accounts?.user?.name || "N/A"}
      </td>

      <td style={tdStyle}>
        { moment.utc(appointment?.created_at).format('MMM D, YYYY hh:mm A') || 'N/A'}
      </td>


      <td style={tdStyle}>
        {statuses?.find(status => status.value == appointment?.status)?.label}
        {/* {confirmationBadge?.text && (
          <span className={`badge badge-pill badge-${confirmationBadge.type} confirmation-badge`}>
            {confirmationBadge.text}
          </span>
        )} */}
      </td>

      {checkPermission('Edit Appointments') &&
        <td style={tdStyle}>
          <div className="row_check">
            <button className="table_edit" onClick={() =>
              handleAddPopUp({ ...appointment, status })}>Edit</button>
          </div>
        </td>
      }
    </tr>
  )
}


export default AppointmentList;
